<div
	class="multi-deposit-limit-message"
	test-id="multi-deposit-limit-message"
	data-test-id="multi-deposit-limit-message"
	*ngIf="(multiDepositLimits$ | async)?.depositLimit as depositLimits"
>
	<div class="multi-deposit-limit-message-header">
		<img obgImageContent="general.warning" />
		<h1 class="multi-deposit-limit-message-header-title">{{ "deposit-limit.change-deposit-limit" | translate }}</h1>
	</div>

	<div class="multi-deposit-limit-message-changes">
		<div class="multi-deposit-limit-message-changes-title">
			<p>{{ "deposit-limit.current-limit-title" | translate }}</p>
			<p>{{ "deposit-limit.new-limit" | translate }}</p>
		</div>

		<div class="multi-deposit-limit-message-changes-content">
			<div *ngFor="let period of depositLimitPeriods" class="multi-deposit-limit-message-changes-content-row">
				<div class="content-item">
					<p class="content-item-title">{{ "deposit-limit." + period | translate }}</p>
					<p class="content-item-amount">
						{{ depositLimits[period + "DepositLimit"] | obgCurrency: undefined : undefined : "1.0-2" }}
					</p>
				</div>
				<span
					[ngClass]="
						depositLimits[period + 'DepositLimit'] !== dialogData.newDepositLimits[period + 'DepositLimit']
							? 'limit-changed'
							: ''
					"
					[class]="'ico ico-deposit-limit-' + period"
				></span>
				<div class="content-item">
					<p class="content-item-title">{{ "deposit-limit." + period | translate }}</p>
					<p
						class="content-item-amount"
						[ngClass]="
							depositLimits[period + 'DepositLimit'] !==
							dialogData.newDepositLimits[period + 'DepositLimit']
								? 'limit-changed'
								: ''
						"
					>
						{{
							dialogData.newDepositLimits[period + "DepositLimit"]
								| obgCurrency: undefined : undefined : "1.0-2"
						}}
					</p>
				</div>
			</div>
		</div>
	</div>

	<div class="multi-deposit-limit-message-info">
		<p class="multi-deposit-limit-message-info-text" *ngIf="dialogData.displayInfoText">
			{{ "deposit-limit.info-text" | translate }}
		</p>
		<p>{{ "deposit-limit.confirm-change" | translate }}</p>
	</div>

	<div class="multi-deposit-limit-message-button-container">
		<button
			class="multi-deposit-limit-message-button"
			test-id="multi-deposit-limit-message-button-confirm"
			data-test-id="multi-deposit-limit-message-button-confirm"
			color="accent"
			mat-flat-button
			(click)="onConfirm()"
		>
			{{ "general.continue" | translate }}
		</button>
		<button
			class="multi-deposit-limit-message-button"
			test-id="multi-deposit-limit-message-button-cancel"
			data-test-id="multi-deposit-limit-message-button-cancel"
			color="primary"
			mat-stroked-button
			(click)="onCancel()"
		>
			{{ "general.cancel" | translate }}
		</button>
	</div>
</div>
